import {Link, useParams} from 'react-router-dom'
import {isInBetaType, RIF, useCurrentProjectState} from '../../lib'
import {selectBatchData, selectTheme, useSelectSettings} from '../../store'
import {BetaType, IParticipant} from '../../shared/db'
import {DataDownloadSection} from './data_download_section'

export interface ProjectSwitchBarProps {
  projectPanel: string
}

export const ProjectSwitchBar = (props: ProjectSwitchBarProps) => {
  const {color} = selectTheme()

  const {projectPanel, ...rest} = props

  const {projectId, project} = useCurrentProjectState()
  const batchId = project?.batchList?.[0]?.id ?? ''
  const batchData = selectBatchData()
  const participantList: IParticipant[] = batchData?.[batchId]?.participantList || []

  const settings = useSelectSettings()
  const {adherenceType} = useParams()

  return (
    <div
      css={{
        width: '100%',
        marginTop: '48px',
        height: '56px',
      }}>
      <div
        {...rest}
        css={{
          width: '100%',
          height: '56px',
          boxSizing: 'border-box',
          backgroundColor: color.white,
          position: 'fixed',
          top: '48px',
          left: '0',
          padding: '0 30px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTop: `1px solid ${color.grey_100}`,
          zIndex: 98,
          boxShadow: '0px 2px 10px 0px #0000000A',
        }}>
        <div
          css={{
            height: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}>
          <Link to={`/dashboard/${projectId}`}>
            <Tab name='Overview' {...{projectPanel}} />
          </Link>
          <Link to={`/participants/${projectId}`}>
            <Tab name='Participants' {...{projectPanel}} />
          </Link>
          <Link to={`/adherence/${projectId}/${adherenceType ?? 'overview'}`}>
            <Tab name='Adherence' {...{projectPanel}} />
          </Link>
          <Link to={`/data_visualization/${projectId}/${participantList[0]?.id}`}>
            <Tab beta={true} name='Data Visualization' {...{projectPanel}} />
          </Link>
          {RIF(
            isInBetaType({betaType: BetaType.Internal, settings}),
            <Link to={`/data_analysis/correlation /${projectId}`}>
              <Tab beta={true} name='Data Analysis' {...{projectPanel}} />
            </Link>,
          )}
          <Link to={`/settings/${projectId}`}>
            <Tab name='Settings' {...{projectPanel}} />
          </Link>
        </div>
        {/* download section */}
        {/* <DataDownloadSection /> */}
        {RIF(projectId, (projectId) => (
          <DataDownloadSection projectId={projectId} />
        ))}
      </div>
    </div>
  )
}

const Tab = (props: {name: string; projectPanel: string; beta?: boolean}) => {
  const {color, fontWeight, fontSize} = selectTheme()
  const active = props.projectPanel === props.name
  return (
    <div
      css={{
        fontWeight: fontWeight.bold,
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        marginRight: '40px',
        cursor: 'pointer',
        color: `${active ? color.primary : color.black}`,
        borderBottom: `${active ? '2px' : '0px'} ${color.primary} solid`,
        ':hover': {
          color: color.primary,
        },
      }}>
      {props.name}
      {RIF(
        props.beta,
        <p
          aria-label='Beta feature tag'
          role='img'
          css={{
            padding: '2px 6px',
            borderRadius: '2px',
            marginLeft: '8px',
            backgroundColor: color.grey_50,
            color: color.grey_400,
            fontWeight: fontWeight.thick,
            fontSize: fontSize.h7,
          }}>
          Beta
        </p>,
      )}
    </div>
  )
}
